import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card as MuiCard, CardContent, Typography, Box, CardActionArea } from '@mui/material';

const Card = ({ title, children, link, ...props }) => {
  const cardContent = (
    <CardContent sx={{ flexGrow: 1 }}>
      {title && (
        <Typography variant="h6" component="div" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <Box>
        {children}
      </Box>
    </CardContent>
  );

  const cardStyles = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    border: '3px solid',
    borderColor: 'divider',
    transition: 'box-shadow 0.3s, transform 0.2s',
    '&:hover': {
      boxShadow: 6,
      transform: 'translateY(-2px)',
    },
    ...props.sx
  };

  if (link) {
    return (
      <MuiCard sx={cardStyles} {...props}>
        <CardActionArea component={RouterLink} to={link} sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          {cardContent}
        </CardActionArea>
      </MuiCard>
    );
  }

  return (
    <MuiCard sx={cardStyles} {...props}>
      {cardContent}
    </MuiCard>
  );
};

export default Card;
